import { createReducer } from '@reduxjs/toolkit'
import { IStateStationStatuses } from './TReducer'
import { Actions_StationStatuses } from './Actions'

const initialState: IStateStationStatuses = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerStationStatuses = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_StationStatuses.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_StationStatuses.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_StationStatuses.store.saveStationStatuses, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerStationStatuses
